// Central site configuration, assets, and constants

export const ASSETS = {
  brandLogo: process.env.PUBLIC_URL + "/ascendance-logo-new.png?v=2",
  heroBg: "https://images.pexels.com/photos/3591962/pexels-photo-3591962.jpeg",
  manifestoBg: "https://images.pexels.com/photos/6800730/pexels-photo-6800730.jpeg",
  dhLogo: "https://customer-assets.emergentagent.com/job_defense-gateway/artifacts/2nx5qpuz_image.png",
  opsLogo: "https://customer-assets.emergentagent.com/job_defense-gateway/artifacts/905z27on_image.png",
  dhProduct: process.env.PUBLIC_URL + "/dh-ammo.jpg?v=4",
  opsProduct: process.env.PUBLIC_URL + "/ops-seat.jpg?v=2",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Innovation", to: "/innovation" },
  { label: "Newsroom", to: "/newsroom" },
  { label: "Contact", to: "/contact" },
];

export const PRODUCTS = [
  {
    id: "dh-armament",
    name: "Dark Horse Ammunition",
    tagline: "Precision Ammunition",
    description:
      "Lead and copper-free ammunition solutions that protect shooters and the environment while providing unmatched reliability and precision.",
    href: "https://dh-armament.com",
    logo: ASSETS.dhLogo,
    image: ASSETS.dhProduct,
    span: "md:col-span-7",
    comingSoon: false,
    badge: "Available Now",
  },
  {
    id: "occupant-shield",
    name: "Occupant Shield",
    tagline: "Armored Seat Systems",
    description:
      "Purpose-built vehicle protection when the mission, and your life, depends on it.",
    href: "https://occupant-shield.com",
    logo: ASSETS.opsLogo,
    image: ASSETS.opsProduct,
    span: "md:col-span-5",
    comingSoon: false,
    badge: "Available Now",
  },
  {
    id: "handguards",
    name: "nTHERM Handguards",
    tagline: "Heat Mitigation",
    description:
      "Thermal failure is now an engineering choice: The world's first MIL-SPEC handguard that stays cool to the touch while the barrel is red-hot.\n\nThey told us it was impossible, then they called it a gimmick — until they realized their hands weren't burning after the fifth mag.",
    features: ["H&K 416 Configurable", "M4 Configurable", "Quad Rail"],
    href: null,
    logo: null,
    image: process.env.PUBLIC_URL + "/ntherm-handguard.jpg?v=3",
    span: "md:col-span-6",
    comingSoon: false,
    badge: "Available Now",
  },
  {
    id: "suppressors",
    name: "Radix Suppressors",
    tagline: "In Development",
    description:
      "Suppress the signature, not the performance.\nFinally, a suppressor that doesn't fight your rifle.",
    href: null,
    logo: null,
    image: process.env.PUBLIC_URL + "/radix-suppressor.jpg?v=2",
    span: "md:col-span-6",
    comingSoon: true,
    badge: "Coming Soon",
  },
];

export const COMPANY = {
  name: "Ascendance International",
  address: "1221 W Mineral Ave, STE 101, Littleton, Colorado 80120",
  phone: "+1.303.284.3615",
  email: "info@ascendanceintl.com",
  socials: [],
};

export const STATS = [
  { value: 30, suffix: "%", label: "Weight Reduction", sub: "via nTHERM composites" },
  { value: 500, suffix: "°C", label: "Heat Resistance", sub: "sustained thermal load" },
  { value: 3, suffix: "x", label: "Impact Durability", sub: "vs. legacy materials" },
  { value: 12, suffix: "+", label: "Defense Programs", sub: "active evaluations" },
];

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
